import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';

import {DressesCarouselComponent} from '../../components/dresses-carousel/dresses-carousel.component';
import {RoutingService} from '../../services/routing-service/routing.service';
import {Router} from '@angular/router';
import {UiService} from '../../services/ui-service/ui.service';
import {ApiService} from '../../services/api-service/api.service';

@Component({
	selector: 'app-p-dresses',
	templateUrl: './page-dresses.component.html',
	styleUrls: ['./page-dresses.component.scss']
})
export class PageDressesComponent implements OnInit, AfterViewInit {
	//todo implement viewParent/viewChild relations
	

	
	@ViewChild(DressesCarouselComponent)
	private currentPageUrl = '/';
	//todo find out how to react to data change (some sort of onChange, etc. but for Observables)
	
	ngAfterViewInit() {
		//    todo set child route
	}
	
	// getCurrentPageUrl = (): void => {
	// 	this.routingService.getCurrentPageUrl().subscribe(
	// 		currentPageUrl => {
	// 			this.currentPageUrl = currentPageUrl;
	// 		}
	// 	);
	// };
	
	// constructor(private routingService: RoutingService, private router: Router) {
	// }
	
	// ngOnInit() {
	// 	// this.getCurrentPageUrl();
	// }
	
	constructor(private UIService: UiService,private apiService: ApiService) {
		
	
	}

	ngOnInit() {}
}
